var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkMOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.7998,
    y: 0.796875,
    width: 24.4004,
    height: 26.4062
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_20_131_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6H8C7.44772 6 7 6.44772 7 7V22L14 17L21 22V7C21 6.44772 20.5523 6 20 6Z",
    fill: "#191F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5.40039C20.8837 5.40039 21.5996 6.11634 21.5996 7V22C21.5996 22.2247 21.4742 22.4304 21.2744 22.5332C21.0746 22.636 20.8342 22.6189 20.6514 22.4883L14 17.7373L7.34863 22.4883C7.16576 22.6189 6.92539 22.636 6.72559 22.5332C6.52575 22.4304 6.40039 22.2247 6.40039 22V7C6.40039 6.11634 7.11634 5.40039 8 5.40039H20Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_20_131_clip_path",
    transform: "translate(-1.7998 -0.796875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6H8C7.44772 6 7 6.44772 7 7V22L14 17L21 22V7C21 6.44772 20.5523 6 20 6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkMOn);
export default __webpack_public_path__ + "static/media/bookmark_M_ON.08b58dc145b5dfe9aee79d12def85ab7.svg";
export { ForwardRef as ReactComponent };